import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { EntityUserProfileCard } from '@backstage/plugin-org';

// Replaces the org plugin's stock user profile card (same 'user-profile'
// extension id) to render metadata.links - the Workspace sync puts a
// "Message on Slack" link there for Slack-matched users, which the stock
// card hides by default.
const savrUserProfileCard = EntityCardBlueprint.make({
  name: 'user-profile',
  params: {
    type: 'info',
    filter: { kind: 'user' },
    loader: async () => <EntityUserProfileCard showLinks />,
  },
});

// The Slack channel from `slack.com/channel`, on the team's own page. The
// same annotation is what the licence views resolve a component's owner to,
// so a team has one place to set it and it shows up in both.
const savrTeamContactCard = EntityCardBlueprint.make({
  name: 'team-contact',
  params: {
    type: 'info',
    filter: { kind: 'group' },
    loader: async () =>
      import('../org/TeamContactCard').then(m => <m.TeamContactCard />),
  },
});

export const orgModule = createFrontendModule({
  pluginId: 'org',
  extensions: [savrUserProfileCard, savrTeamContactCard],
});
